// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"132":"62a1b76c","479":"f8e009c0","838":"a66a7c6f"}[chunkId] + ".js";
};